module.exports = __webpack_public_path__ + "static/media/south-region-states-sm.446ca49d.png";